export const mockJournals = [
  {
    id: 'jqcis',
    title: 'Journal of Quantum Computing & Information Systems',
    shortTitle: 'JQCIS',
    description: 'A sample peer-reviewed journal structure demonstrating publication scope for research in quantum computing, quantum information theory, and quantum communication systems.',
    aimsAndScope: 'This sample journal would publish original research articles, comprehensive review papers, and technical communications across all areas of quantum computing and information science. Topics include quantum algorithms, quantum cryptography, quantum error correction, quantum complexity theory, quantum networking, and hybrid classical-quantum computational models. The journal would welcome contributions from theoretical computer scientists, physicists, mathematicians, and engineers working at the intersection of quantum mechanics and information processing.',
    field: 'Computer Science & Quantum Physics',
    frequency: 'Quarterly',
    currentVolume: 1,
    currentIssue: 1,
    acceptanceRate: 'Under Review',
    submissionDeadline: 'Rolling submissions',
    reviewTime: '6–8 weeks',
    editorInChief: 'Editor — MAH Quantum Research Institute',
    isDemoJournal: true,
    issn: 'Pending Assignment',
    eIssn: 'Pending Assignment',
    impactFactor: 'Not Yet Rated',
    indexing: ['Google Scholar', 'Zenodo', 'DOAJ (Pending)'],
  },
  {
    id: 'jams',
    title: 'Journal of Advanced Materials Science',
    shortTitle: 'JAMS',
    description: 'A sample journal structure dedicated to demonstrating the publication scope for research in advanced functional materials, nanomaterials, and smart material systems.',
    aimsAndScope: 'This sample journal would cover research in nanomaterials, biomaterials, electronic and photonic materials, energy storage materials, structural composites, and materials for environmental applications. It would publish experimental studies, computational material science, and multiscale modeling work, encouraging interdisciplinary contributions from chemistry, physics, and engineering.',
    field: 'Materials Science & Engineering',
    frequency: 'Bimonthly',
    currentVolume: 1,
    currentIssue: 1,
    acceptanceRate: 'Under Review',
    submissionDeadline: 'Rolling submissions',
    reviewTime: '4–6 weeks',
    editorInChief: 'Editor — MAH Quantum Research Institute',
    isDemoJournal: true,
    issn: 'Pending Assignment',
    eIssn: 'Pending Assignment',
    impactFactor: 'Not Yet Rated',
    indexing: ['Google Scholar', 'Zenodo', 'DOAJ (Pending)'],
  },
  {
    id: 'jbmi',
    title: 'Journal of Biomedical & Molecular Innovations',
    shortTitle: 'JBMI',
    description: 'A sample journal structure at the frontier of biomedical research, demonstrating publication scope for molecular biology, genomics, proteomics, and precision medicine.',
    aimsAndScope: 'This sample journal would advance understanding of biological systems at the molecular level, with emphasis on translational research. Areas of focus would include gene editing technologies, drug discovery and development, biomarker identification, single-cell analysis, structural biology, and computational biology.',
    field: 'Biomedical Sciences & Molecular Biology',
    frequency: 'Monthly',
    currentVolume: 1,
    currentIssue: 1,
    acceptanceRate: 'Under Review',
    submissionDeadline: 'Rolling submissions',
    reviewTime: '5–7 weeks',
    editorInChief: 'Editor — MAH Quantum Research Institute',
    isDemoJournal: true,
    issn: 'Pending Assignment',
    eIssn: 'Pending Assignment',
    impactFactor: 'Not Yet Rated',
    indexing: ['Google Scholar', 'Zenodo', 'DOAJ (Pending)'],
  },
  {
    id: 'jaai',
    title: 'Journal of Artificial Intelligence & Applications',
    shortTitle: 'JAAI',
    description: 'A sample interdisciplinary journal structure covering theoretical advances and practical applications of artificial intelligence, machine learning, and intelligent systems.',
    aimsAndScope: 'This sample journal would publish research on deep learning architectures, reinforcement learning, natural language processing, computer vision, explainable AI, AI ethics and fairness, and applications of AI in healthcare, finance, autonomous systems, and social sciences.',
    field: 'Computer Science & Artificial Intelligence',
    frequency: 'Quarterly',
    currentVolume: 1,
    currentIssue: 1,
    acceptanceRate: 'Under Review',
    submissionDeadline: 'Rolling submissions',
    reviewTime: '6–9 weeks',
    editorInChief: 'Editor — MAH Quantum Research Institute',
    isDemoJournal: true,
    issn: 'Pending Assignment',
    eIssn: 'Pending Assignment',
    impactFactor: 'Not Yet Rated',
    indexing: ['Google Scholar', 'Zenodo', 'DOAJ (Pending)'],
  },
];
